import React, { useEffect, useRef } from 'react';

const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const mouse = useRef({ x: -200, y: -200 });
  const ring = useRef({ x: -200, y: -200 });
  const rafRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia('(hover: none)').matches) return;

    const dot = dotRef.current;
    const ringEl = ringRef.current;
    if (!dot || !ringEl) return;

    const onMove = (e) => {
      mouse.current = { x: e.clientX, y: e.clientY };
    };

    const onEnterLink = () => {
      if (dot) dot.style.transform = 'translate(-50%, -50%) scale(0)';
      if (ringEl) {
        ringEl.style.width = '52px';
        ringEl.style.height = '52px';
        ringEl.style.background = 'rgba(124, 58, 237, 0.15)';
        ringEl.style.borderColor = '#7C3AED';
      }
    };

    const onLeaveLink = () => {
      if (dot) dot.style.transform = 'translate(-50%, -50%) scale(1)';
      if (ringEl) {
        ringEl.style.width = '36px';
        ringEl.style.height = '36px';
        ringEl.style.background = 'transparent';
        ringEl.style.borderColor = 'rgba(37, 99, 235, 0.7)';
      }
    };

    const onDown = () => {
      if (dot) { dot.style.transform = 'translate(-50%, -50%) scale(2.5)'; dot.style.opacity = '0.4'; }
    };
    const onUp = () => {
      if (dot) { dot.style.transform = 'translate(-50%, -50%) scale(1)'; dot.style.opacity = '1'; }
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('mouseup', onUp);

    const attachLinks = () => {
      document.querySelectorAll('a, button').forEach(el => {
        el.addEventListener('mouseenter', onEnterLink);
        el.addEventListener('mouseleave', onLeaveLink);
      });
    };
    attachLinks();

    const observer = new MutationObserver(attachLinks);
    observer.observe(document.body, { childList: true, subtree: true });

    const lerp = (a, b, t) => a + (b - a) * t;
    const loop = () => {
      ring.current.x = lerp(ring.current.x, mouse.current.x, 0.1);
      ring.current.y = lerp(ring.current.y, mouse.current.y, 0.1);
      if (dot) { dot.style.left = mouse.current.x + 'px'; dot.style.top = mouse.current.y + 'px'; }
      if (ringEl) { ringEl.style.left = ring.current.x + 'px'; ringEl.style.top = ring.current.y + 'px'; }
      rafRef.current = requestAnimationFrame(loop);
    };
    rafRef.current = requestAnimationFrame(loop);

    return () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('mouseup', onUp);
      cancelAnimationFrame(rafRef.current);
      observer.disconnect();
    };
  }, []);

  if (typeof window !== 'undefined' && window.matchMedia('(hover: none)').matches) return null;

  const shared = {
    position: 'fixed',
    borderRadius: '50%',
    pointerEvents: 'none',
    zIndex: 99999,
    transform: 'translate(-50%, -50%)',
  };

  return (
    <>
      <div ref={dotRef} style={{
        ...shared,
        width: '8px', height: '8px',
        background: '#7C3AED',
        transition: 'transform 0.12s ease, opacity 0.12s ease',
      }} />
      <div ref={ringRef} style={{
        ...shared,
        zIndex: 99998,
        width: '36px', height: '36px',
        border: '2px solid rgba(37, 99, 235, 0.7)',
        background: 'transparent',
        transition: 'width 0.22s ease, height 0.22s ease, background 0.22s ease, border-color 0.22s ease',
      }} />
    </>
  );
};

export default CustomCursor;